export default "__VITE_ASSET__CGFAckyp__"